import { AlertColor, AlertTitle, Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { DismissButton, MultipleButtons } from '../buttons';
import { StyledAlert } from './alert';

type SideToastWithCategoriesProps = {
  title: string;
  issueTypes: { name: string; child: ReactNode }[];
  type?: AlertColor;
  action?: 'compact' | 'divided';
  onClose?: () => void;
  onAction?: () => void;
};

function SideToastWithCategories({
  type,
  title,
  issueTypes,
  action = 'compact',
  onClose = () => null,
  onAction = () => null,
}: SideToastWithCategoriesProps) {
  const actionElement =
    action === 'compact' ? (
      <DismissButton onClose={onClose} />
    ) : (
      <MultipleButtons onClose={onClose} onAction={onAction} />
    );
  return (
    <StyledAlert
      severity={type}
      action={actionElement}
      variant={title ? 'filled' : 'standard'}
    >
      <AlertTitle>{title}</AlertTitle>
      {issueTypes.map((issueType) => (
        <Box>
          <Typography>{issueType.name}</Typography>
          <Box flexDirection='column'>{issueType.child}</Box>
        </Box>
      ))}
    </StyledAlert>
  );
}

export default SideToastWithCategories;
